<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ props }">
      <div v-bind="props">
        <v-select v-model="model" :class="_props.readonly ? 'custom-readonly' : ''" :items="items"
                  :readonly="_props.readonly" :rules="[_props.required ? v => !!v || 'Bitte Zeit wählen!' : () => true]"
                  :variant="useGlobalSetting().globalTextVariant" item-title="prio"
                  label="Priorität">
          <template v-slot:item="{ props: itemProps, item }">
            <v-list-item
                :subtitle="item.raw.description"
                v-bind="itemProps"
            ></v-list-item>
          </template>
        </v-select>
      </div>
    </template>
    <span>Priorität</span>
  </v-tooltip>
</template>

<script setup>

import {useGlobalSetting} from "@/lib/utils";

const model = defineModel()

const items = [
  {
    prio: '1',
    description: 'Direkt',
  },
  {
    prio: '2',
    description: 'Später oder so',
  },
  {
    prio: '3',
    description: 'digger kp',
  },
]

const _props = defineProps({
  readonly: {
    type: Boolean,
    default: false,
  },
  variant: String,
  required: {
    type: Boolean,
    default: false,
  }
});

</script>
